/* import __COLOCATED_TEMPLATE__ from './checkout.hbs'; */
import {
  STRIPE_PAYMENT_INSTRUMENT_TYPE_ACH,
  STRIPE_PAYMENT_INSTRUMENT_TYPE_CARD,
} from 'client-portal/utils/stripe-payment-instrument';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import CheckoutBase from './checkout/base';
import ENV from 'client-portal/config/environment';

export default class SiteBillingPaymentInstrumentPaymentModalCheckout extends CheckoutBase {
  @service stripePaymentModeElementService;

  @tracked cardStripeElement = null;
  @tracked addingInstrumentType = null;

  get paymentInstrument() {
    return this.paymentModel.stripePaymentInstrument;
  }

  get isCardPayment() {
    return this.paymentModel.stripePaymentInstrumentType === STRIPE_PAYMENT_INSTRUMENT_TYPE_CARD;
  }

  get isAddingCard() {
    return this.addingInstrumentType === STRIPE_PAYMENT_INSTRUMENT_TYPE_CARD;
  }

  @action
  enterAddInstrumentFlow(type) {
    this.addingInstrumentType = type;
  }

  @action
  exitAddInstrumentFlow() {
    this.addingInstrumentType = null;
  }

  get isAddingAch() {
    return this.addingInstrumentType === STRIPE_PAYMENT_INSTRUMENT_TYPE_ACH;
  }

  get childOwnsModalActions() {
    // 'Adding ACH' uses Save/Cancel on the setup element (save before pay).
    return this.isAddingAch;
  }

  get isStripeElementLoaded() {
    if (!this.paymentInstrument?.isNew || !this.isCardPayment) {
      return false;
    }

    return this.stripePaymentModeElementService.isLoaded;
  }

  get showPayButton() {
    const instrument = this.paymentInstrument;
    if (!instrument) return false;
    if (!instrument.isNew) return true;

    // When paying with a new card, show Pay once the Stripe element is ready.
    return this.isAddingCard && this.isStripeElementLoaded;
  }

  get cancelDisabled() {
    return (
      this.paymentInstrumentModals.isPersisting ||
      this.stripeExpressCheckoutElementService.isPersisting
    );
  }

  @action
  collectDeviceData() {
    if (ENV.railsEnv !== 'test' && window.ka?.ClientSDK) {
      new window.ka.ClientSDK().autoLoadEvents();
    }
  }

  @action
  setCardStripeElement(stripeElement) {
    this.cardStripeElement = stripeElement;
  }

  @action
  persistPayment() {
    // Stripe element is only needed when paying with a new card.
    const stripeElement =
      this.isCardPayment && this.paymentInstrument?.isNew ? this.cardStripeElement : null;

    return this.paymentInstrumentModals.persistPayment(stripeElement);
  }
}
